var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadRevision(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "10.5 11 19 17.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.8333L18.8214 19.5118C19.4723 18.861 20.5276 18.861 21.1785 19.5118L22.5 20.8333M20 19.1667V23.3333M28.3333 18.3333V24.1667C28.3333 26.0076 26.8409 27.5 25 27.5H15C13.159 27.5 11.6666 26.0076 11.6666 24.1667V15.8333C11.6666 13.9924 13.159 12.5 15 12.5H17.2222C17.9434 12.5 18.6452 12.7339 19.2222 13.1667L20.7777 14.3333C21.3547 14.7661 22.0565 15 22.7777 15H25C26.8409 15 28.3333 16.4924 28.3333 18.3333Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadRevision);
export default __webpack_public_path__ + "static/media/upload-revision.8dc62debe57839975b940ab9f035a4b9.svg";
export { ForwardRef as ReactComponent };